module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("商品标签")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "tagId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "标签名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "创建时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建标签"
    },
    model: {
      value: (_vm.addTag),
      callback: function($$v) {
        _vm.addTag = $$v
      },
      expression: "addTag"
    }
  }, [_c('el-form', {
    ref: "tagForm",
    attrs: {
      "model": _vm.tagForm,
      "rules": _vm.addTagRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标签名称",
      "label-width": "120px",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.tagForm.name),
      callback: function($$v) {
        _vm.$set(_vm.tagForm, "name", $$v)
      },
      expression: "tagForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签描述",
      "label-width": "120px",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.tagForm.description),
      callback: function($$v) {
        _vm.$set(_vm.tagForm, "description", $$v)
      },
      expression: "tagForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleNewTag
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑标签"
    },
    model: {
      value: (_vm.editTag),
      callback: function($$v) {
        _vm.editTag = $$v
      },
      expression: "editTag"
    }
  }, [_c('el-form', {
    ref: "tagForm",
    attrs: {
      "model": _vm.tagForm,
      "rules": _vm.addTagRules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标签名称",
      "label-width": "120px",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.tagForm.name),
      callback: function($$v) {
        _vm.$set(_vm.tagForm, "name", $$v)
      },
      expression: "tagForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签描述",
      "label-width": "120px",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.tagForm.description),
      callback: function($$v) {
        _vm.$set(_vm.tagForm, "description", $$v)
      },
      expression: "tagForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editTag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpdateTag
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49bad71e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/ProductTag.vue
// module id = 730
// module chunks = 1